import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * Tabs enable quick switch between different views.
 */
const Tabs = (props) => {
  const { className, tabs, vertical, onChange, activeIndex, ...otherProps } = props;
  const [activeIndexState, setActiveIndexState] = useState(0);
  const classNames = classnames('tab tab-block text-lg', className, { 'tab-vertical': vertical });
  const activeTabIndex = activeIndex !== -1 ? activeIndex : activeIndexState;
  return (
    <React.Fragment>
      <div className={classNames} {...otherProps}>
        {
          tabs.map((tab, index) => (
            <div
              className={classnames('tab-item', { active: index === activeTabIndex })}
              key={tab.key}
            >
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  onChange(index);
                  if (activeIndex === -1) {
                    setActiveIndexState(index);
                  }
                }}
              >
                {tab.title}
              </a>
            </div>
          ))
        }
      </div>
    </React.Fragment>
  );
};

Tabs.propTypes = {
  /** Additional classes. */
  className: PropTypes.string,
  /** A vertical tab menu can be positioned on either side. */
  vertical: PropTypes.bool,
  /** Called on tab change. */
  onChange: PropTypes.func,
  /** Active tab index. */
  activeIndex: PropTypes.number,
};

Tabs.defaultProps = {
  className: '',
  vertical: false,
  onChange: () => {},
  activeIndex: -1,
};

export { Tabs };
